var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavGiftOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 468",
    style: {
      fill: "none"
    },
    d: "M0 0h26v26H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 120",
    d: "M354.864 6.749a1.747 1.747 0 0 1-.79-.215l-4.559-2.308a1.573 1.573 0 0 1-.915-1.266 1.573 1.573 0 0 1 .7-1.4l1.649-1.2a1.866 1.866 0 0 1 1.1-.364 1.842 1.842 0 0 1 1.616.987l2.065 3.848a1.348 1.348 0 0 1 .079 1.395 1.086 1.086 0 0 1-.947.52m-4.18-3.958 2.61 1.322-1.219-2.272a.081.081 0 0 0-.027-.035.188.188 0 0 0-.036.02z",
    transform: "translate(-342.353 .867)",
    style: {
      fill: "#222729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121",
    d: "M370.55 6.878a1.106 1.106 0 0 1-.961-.523 1.356 1.356 0 0 1 .064-1.4l1.888-3.61a1.829 1.829 0 0 1 1.613-1 1.859 1.859 0 0 1 1.1.365l1.656 1.206a1.562 1.562 0 0 1 .7 1.4 1.561 1.561 0 0 1-.939 1.254l-4.35 2.1a1.759 1.759 0 0 1-.77.2m2.607-4.72-.015.028-1.124 2.147 2.482-1.2-1.312-.958a.111.111 0 0 0-.031-.018",
    transform: "translate(-356.643 .627)",
    style: {
      fill: "#222729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 122",
    d: "M355.676 43.509H335.9a1.257 1.257 0 0 1-1.257-1.257v-13.4a1.257 1.257 0 0 1 1.257-1.257h19.772a1.257 1.257 0 0 1 1.257 1.257v13.4a1.257 1.257 0 0 1-1.257 1.257",
    transform: "translate(-332.791 -18.058)",
    style: {
      fill: "#222729"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 463",
    transform: "translate(10.223 13.377)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h5.554v12.074H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 133",
    d: "M353.479 23.936h-23.486a1.257 1.257 0 0 1-1.257-1.257v-4.107a1.257 1.257 0 0 1 1.257-1.257h23.487a1.257 1.257 0 0 1 1.257 1.257v4.107a1.257 1.257 0 0 1-1.257 1.257",
    transform: "translate(-328.736 -11.008)",
    style: {
      fill: "#222729"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGiftOff);
export default __webpack_public_path__ + "static/media/nav_gift_off.859766f6b90357f995dc0d541a6780a1.svg";
export { ForwardRef as ReactComponent };